module.exports = __webpack_public_path__ + "img/11-map.0a2c605b.jpg";